import {BaseScenarioData} from './BaseScenarioData'
import {ScenarioSettingEnum} from '@colonist/game-base-types'

export class ScenarioDataNone extends BaseScenarioData {
    scenarioSetting = ScenarioSettingEnum.None
    defaultVPsToWin = 10
}

export class ScenarioDataHeadingForNewShores extends BaseScenarioData {
    scenarioSetting = ScenarioSettingEnum.SS1HeadingForNewShores
    defaultVPsToWin = 14
}

export class ScenarioDataFourIslands extends BaseScenarioData {
    scenarioSetting = ScenarioSettingEnum.SS2TheFourIslands
    defaultVPsToWin = 13
}

export class ScenarioDataFogIsland extends BaseScenarioData {
    scenarioSetting = ScenarioSettingEnum.SS3TheFogIslands
    defaultVPsToWin = 12
}

export class ScenarioDataThroughTheDesert extends BaseScenarioData {
    scenarioSetting = ScenarioSettingEnum.SS4ThroughTheDesert
    defaultVPsToWin = 14
}
